// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3zFex","large":"styles_large__21i3a"};